'use strict';
module.exports = require('./Breadcrumb.vue');